module.exports = __webpack_public_path__ + "static/media/discussion.f5eb9d1e.svg";